import React from 'react';
import TableV2Footer from "../TableV2Footer.js";
import { renderDynamicComponent } from "../util/index.js";
import BasicRowRenderer from "./row/BasicRowRenderer.js";
import { HeaderRenderer, Loading, NoData } from "./util/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function BasicTableRenderer(props) {
  const {
    getTableProps,
    tableRef,
    tableClassName,
    loading,
    loadingMessage,
    headerRef,
    headerGroups,
    tableTheadClassName,
    headerGroupClassName,
    headerClassName,
    headerFlexVariant,
    resizerClassName,
    sortAscClassName,
    sortDescClassName,
    getTableBodyProps,
    bodyRef,
    tableBodyClassName,
    rows,
    listRef,
    paginate,
    page,
    prepareRow,
    rowClassName,
    evenRowClassName,
    oddRowClassName,
    cellClassName,
    getRowProps,
    onItemsRendered,
    itemKey,
    FooterComponent,
    footerProps,
    paginationNextButtonVariant,
    paginationNextButtonIcon,
    paginationNextButtonText,
    paginationPreviousButtonVariant,
    paginationPreviousButtonIcon,
    paginationPreviousButtonText,
    paginationDropdownVariant,
    noDataMessage,
    ...rest
  } = props;
  const {
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    pageIndex,
    pageSize,
    footerClassName
  } = footerProps;
  return /*#__PURE__*/_jsx("div", {
    ...getTableProps({
      ...rest,
      style: {
        ...rest.style,
        minWidth: 0
      }
    }),
    ref: tableRef,
    className: tableClassName,
    children: loading ? /*#__PURE__*/_jsx(Loading, {
      label: loadingMessage
    }) : /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(HeaderRenderer, {
        headerRef: headerRef,
        headerGroups: headerGroups,
        tableTheadClassName: tableTheadClassName,
        headerGroupClassName: headerGroupClassName,
        headerClassName: headerClassName,
        headerFlexVariant: headerFlexVariant,
        resizerClassName: resizerClassName,
        sortAscClassName: sortAscClassName,
        sortDescClassName: sortDescClassName
      }), /*#__PURE__*/_jsx("div", {
        ...getTableBodyProps(),
        ref: bodyRef,
        className: tableBodyClassName,
        children: rows.length > 0 ? /*#__PURE__*/_jsx(BasicRowRenderer, {
          listRef: listRef,
          rows: paginate ? page : rows,
          prepareRow: prepareRow,
          rowClassName: rowClassName,
          evenRowClassName: evenRowClassName,
          oddRowClassName: oddRowClassName,
          cellClassName: cellClassName,
          getRowProps: getRowProps,
          onItemsRendered: onItemsRendered,
          itemKey: itemKey
        }) : /*#__PURE__*/_jsx(NoData, {
          label: noDataMessage
        })
      }), paginate ? FooterComponent ? renderDynamicComponent(FooterComponent, footerProps) : /*#__PURE__*/_jsx(TableV2Footer, {
        canPreviousPage: canPreviousPage,
        canNextPage: canNextPage,
        pageOptions: pageOptions,
        pageCount: pageCount,
        gotoPage: gotoPage,
        nextPage: nextPage,
        previousPage: previousPage,
        setPageSize: setPageSize,
        pageIndex: pageIndex,
        pageSize: pageSize,
        paginationNextButtonVariant: paginationNextButtonVariant,
        paginationNextButtonIcon: paginationNextButtonIcon,
        paginationNextButtonText: paginationNextButtonText,
        paginationPreviousButtonVariant: paginationPreviousButtonVariant,
        paginationPreviousButtonIcon: paginationPreviousButtonIcon,
        paginationPreviousButtonText: paginationPreviousButtonText,
        paginationDropdownVariant: paginationDropdownVariant,
        footerClassName: footerClassName
      }) : null]
    })
  });
}